import {get, post} from "./Request";

const corePath = "Auth/";


export async function Login(model) {
    return await post(`${corePath}Login`, model);
}

